import { render, staticRenderFns } from "./EvaluationComponent.vue?vue&type=template&id=f8f2fd26&"
import script from "./EvaluationComponent.vue?vue&type=script&lang=js&"
export * from "./EvaluationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports